import React, { useState, useEffect,  } from 'react'; 

const styles = {
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '1rem',
    backgroundColor: '#6b0021',
    color: 'white',
    fontWeight: 'bold',
    cursor: 'pointer',
    borderBottom: '1px solid #8a002c',
  },
  title: {
    margin: 0,
    fontSize: '1.1rem',
  },
  icon: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    transition: 'transform 0.2s ease',
  },
  contentWrapper: {
    maxHeight: 0,
    overflow: 'hidden', 
    transition: 'max-height 0.4s ease-out', 
    backgroundColor: 'white', 
  },
  contentWrapperOpen: {
    maxHeight: '2000px', 
    transition: 'max-height 0.4s ease-in',
  },
  content: {
    padding: '1rem', 
  }
};

const AcordionItem = ({ title, children, isOpen, onClick }) => {
  const [allowOverflow, setAllowOverflow] = useState(false);

  // Efecto para manejar el tiempo de la animación
  useEffect(() => {
    let timer;
    if (isOpen) {
      // Si se abre, esperamos 400ms  para quitar el hidden
      timer = setTimeout(() => {
        setAllowOverflow(true);
      }, 400); 
    } else {
      setAllowOverflow(false);
    }
    return () => clearTimeout(timer);
  }, [isOpen]);
  
  const iconStyle = {
    ...styles.icon,
    transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)',
  };
  
  const contentStyle = {
    ...styles.contentWrapper,
    ...(isOpen ? styles.contentWrapperOpen : {}),
    overflow: allowOverflow ? 'visible' : 'hidden', 
  };

  return (
    <div style={{ marginBottom: '5px' }}>
      <div style={styles.header} onClick={onClick} role="button" tabIndex={0} onKeyPress={onClick}>
        <h2 style={styles.title}>{title}</h2>
        <span style={iconStyle}>+</span>
      </div>
      
      <div style={contentStyle}>
        <div style={styles.content}>
            {children}
        </div>
      </div>
    </div>
  );
};

export default AcordionItem;